import { GetterTree } from 'vuex/types';
import { State } from "@/store/types";
import { UserSourceState } from "./state";

const getters: GetterTree<UserSourceState, State> = {
  hasUserSource: userSource => Boolean(userSource.source) || Boolean(userSource.campaign) || Boolean(userSource.medium) || Boolean(userSource.content),
};

export default getters;
